export const editCourseTabs = [
  { id: "details", label: "Details" },
  { id: "content", label: "Content and versions" },
  { id: "availability", label: "Availability" },
] as const;

export type EditCourseTabId = (typeof editCourseTabs)[number]["id"];

/** The edit course page opens on Content and versions when the URL names no tab. */
export const defaultEditCourseTab: EditCourseTabId = "content";

export const isEditCourseTabId = (value: unknown): value is EditCourseTabId =>
  editCourseTabs.some((tab) => tab.id === value);

export type EditCourseSearchParams = {
  tab?: EditCourseTabId;
};

export const validateEditCourseSearch = (
  search: Record<string, unknown>,
): EditCourseSearchParams => ({
  tab: isEditCourseTabId(search.tab) ? search.tab : undefined,
});
